<nav class="navbar pt-0 navbar-expand-lg navbar-default bg-default navbar-static-side" role="navigation">
  <div class="sidebar-collapse">
    <ul class="nav metismenu" id="side-menu">
      <li class="nav-header full-width">
        <div class="profile-element">
          <feature-loading-skeleton shape="circle" size="3rem" borderRadius="undefined"></feature-loading-skeleton>
          <div>
            <feature-loading-skeleton width="170px" height="20px" className="m-t-xs"></feature-loading-skeleton>
            <feature-loading-skeleton width="170px" height="20px" className="m-t-xs"></feature-loading-skeleton>
          </div>
        </div>
      </li>
      <li class="full-width nav-items-style block">
        <ng-container *ngFor="let item of [].constructor(navbarItems)">
          <feature-loading-skeleton width="170px" height="30px" className="my-3"></feature-loading-skeleton>
        </ng-container>
      </li>
    </ul>
  </div>
</nav>
